<template>
  <div class="modal fade" id="new-food-handler" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-capitalize" id="exampleModalLongTitle">Food Handler Certificate Application</h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>

          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">First Name</label>
                <input
                    v-model="localApplicant.firstName"
                    type="text"
                    class="form-control"
                    placeholder="Enter first name"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Other Name(s)</label>
                <input
                    v-model="localApplicant.otherNames"
                    type="text"
                    class="form-control"
                    placeholder="Enter Other Names"
                >
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">ID Number</label>
                <input
                    v-model="localApplicant.idNumber"
                    type="text"
                    class="form-control"
                    placeholder="Enter ID Number"
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Phone Number</label>
                <input
                    v-model="localApplicant.phoneNumber"
                    type="text"
                    class="form-control"
                    placeholder="Enter phone No."
                >
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-email-input" class="form-label">Email Address</label>
                <input
                    v-model="localApplicant.email"
                    type="text"
                    class="form-control"
                    placeholder="email@email.com"
                >
              </div>
            </div>

            <div class="col-xl-12 col-sm-12">
              <div class="mt-4">
                <h5 class="font-size-14 mb-4 text-capitalize">Gender</h5>
                <div class="d-flex">
                  <div class="form-check mb-3 pr-4">
                    <input
                        v-model="localApplicant.gender"
                        class="form-check-input"
                        type="radio"
                        name="Gender"
                        id="gender-male"
                        value="Male"
                    >
                    <label class="form-check-label" for="gender-male">
                      Male
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                        v-model="localApplicant.gender"
                        class="form-check-input"
                        type="radio"
                        name="Gender"
                        id="gender-female"
                        value="Female"
                    >
                    <label class="form-check-label" for="gender-female">
                      Female
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Sub County</label>
                <select
                    v-model="localApplicant.subCountyID"
                    class="form-control selectpicker bg-white"
                    title="Select Applicant's subcounty"
                    data-live-search="true"
                >
                  <option
                      v-for="(sub, index) in subCounties"
                      :key="index"
                      :value="sub.subCountyID"
                  >
                    {{ sub.subCountyName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="formrow-firstname-input" class="form-label">Ward</label>
                <select
                    v-model="localApplicant.wardID"
                    class="form-control selectpicker bg-white"
                    title="Select Applicant's Ward"
                    data-live-search="true"
                >
                  <option
                      v-for="(ward, index) in wards"
                      :key="index"
                      :value="ward.wardID"
                  >
                    {{ ward.wardName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="handleSubmit" type="button" class="btn btn-primary w-100">Create License</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FoodHandlerModal',

  props: {
    applicant: {
      type: Object,
      default: () => ({
        firstName: '',
        otherNames: '',
        idNumber: '',
        phoneNumber: '',
        email: '',
        gender: 'Male',
        subCountyID: '',
        wardID: ''
      })
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    wards: {
      type: Array,
      default: () => []
    },
    message: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      localApplicant: { ...this.applicant }
    }
  },

  watch: {
    applicant: {
      handler(newVal) {
        this.localApplicant = { ...newVal }
      },
      deep: true
    }
  },

  methods: {
    handleSubmit() {
      // Validation
      if (!this.localApplicant.firstName) {
        this.$emit('update:message', 'First Name is required')
        return
      }
      if (!this.localApplicant.idNumber) {
        this.$emit('update:message', 'ID Number is required')
        return
      }
      if (!this.localApplicant.phoneNumber) {
        this.$emit('update:message', 'Phone Number is required')
        return
      }

      this.$emit('submit-application', this.localApplicant)
    }
  }
}
</script>